// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var CleanupT = function (x) {
    return x;
};
var runCleanupT = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (v) {
        return bind(liftEffect(Specular_Internal_Effect.emptyDelayed))(function (actionsMutable) {
            return bind(Control_Monad_Reader_Trans.runReaderT(v)(actionsMutable))(function (result) {
                return bind(liftEffect(Specular_Internal_Effect.unsafeFreezeDelayed(actionsMutable)))(function (actions) {
                    return pure(new Data_Tuple.Tuple(result, Specular_Internal_Effect.sequenceEffects(actions)));
                });
            });
        });
    };
};
var onCleanup = function (dict) {
    return dict.onCleanup;
};
var monadTransCleanupT = {
    lift: function (dictMonad) {
        var $42 = lift(dictMonad);
        return function ($43) {
            return CleanupT($42($43));
        };
    }
};
var monadEffectCleanupT = function (dictMonadEffect) {
    return Control_Monad_Reader_Trans.monadEffectReader(dictMonadEffect);
};
var monadCleanupT = function (dictMonad) {
    return Control_Monad_Reader_Trans.monadReaderT(dictMonad);
};
var monadCleanupReaderT = function (dictMonadCleanup) {
    var Monad0 = dictMonadCleanup.Monad0();
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        onCleanup: (function () {
            var $44 = lift(Monad0);
            var $45 = onCleanup(dictMonadCleanup);
            return function ($46) {
                return $44($45($46));
            };
        })(),
        Monad0: function () {
            return monadReaderT;
        }
    };
};
var monadCleanupCleanupT = function (dictMonadEffect) {
    var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
    var monadCleanupT1 = monadCleanupT(dictMonadEffect.Monad0());
    return {
        onCleanup: function (action) {
            return function (actions) {
                return liftEffect(Specular_Internal_Effect.pushDelayed(actions)(action));
            };
        },
        Monad0: function () {
            return monadCleanupT1;
        }
    };
};
var functorCleanupT = function (dictFunctor) {
    return Control_Monad_Reader_Trans.functorReaderT(dictFunctor);
};
var execCleanupT = function (dictMonadEffect) {
    var $47 = Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.snd);
    var $48 = runCleanupT(dictMonadEffect);
    return function ($49) {
        return $47($48($49));
    };
};
var bindCleanupT = function (dictBind) {
    return Control_Monad_Reader_Trans.bindReaderT(dictBind);
};
var applyCleanupT = function (dictApply) {
    return Control_Monad_Reader_Trans.applyReaderT(dictApply);
};
var applicativeCleanupT = function (dictApplicative) {
    return Control_Monad_Reader_Trans.applicativeReaderT(dictApplicative);
};
export {
    onCleanup,
    CleanupT,
    runCleanupT,
    execCleanupT,
    functorCleanupT,
    applyCleanupT,
    applicativeCleanupT,
    bindCleanupT,
    monadCleanupT,
    monadEffectCleanupT,
    monadTransCleanupT,
    monadCleanupCleanupT,
    monadCleanupReaderT
};
